import React from 'react';
import './Error.css'; 
function SubmitNotFoundEmail() {
  return (
    <div className="submit_error wrapper">
      <h1>入力されたメールアドレスは、登録されていません。</h1> 
      <div >
        <h3>入力されたメールアドレスが正しいかどうかお確かめください。</h3>
      </div>
      <div className='error_h4'>
        <h4>らくらく連絡網カスタマーサポート：ra9-cs@eu-phoria.jp</h4>
      </div>
    </div>
  );
}
export default SubmitNotFoundEmail;